// Path: ./src/app/components/AccountSidebarDrawer/styled.ts
import styled from "styled-components";

export const DrawerWrapper = styled.div`
  background-color: #4c4c4c;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const DrawerContainer = styled.div`
  margin-top: 25px;
  padding-bottom: 80px;
  flex: 1;
  overflow-y: auto;
`;

export const LinkWrapper = styled.div`
  margin-top: -25px;
`;

export const StandAloneLinkWrapper = styled.div`
  margin-top: 1rem;
  color: #fff;
`;
